import { computed } from 'vue'
import { useTapStore } from '@/stores/tapStore'

export function useBlocks() {
    const tapStore = useTapStore()
    const blocks = computed(() => tapStore.currentTapLang?.blocks ?? [])

    const normalizeBlocksOrder = () => {
        let tapChanged = false;
        blocks.value.forEach((b, i) => {
            b.changed = b.changed || b.orderIndex !== i + 1
            b.orderIndex = i + 1
            if(b.changed) tapChanged = true;
        })
        if(tapChanged) tapStore.currentTapLang.changed = true;
    }

    const moveBlock = (block, directionUp) => {
        const arr = blocks.value
        const index = arr.findIndex(b => b.uniqueId === block.uniqueId)
        const newIndex = directionUp ? index - 1 : index + 1
        if (newIndex < 0 || newIndex >= arr.length) return

        const temp = arr[newIndex]
        arr[newIndex] = arr[index]
        arr[index] = temp
        normalizeBlocksOrder()
        saveMoveBlock(block.uniqueId, newIndex)
    }

    const saveMoveBlock = (uniqueId, newIndex) => {
        const tapApi = useTapApi();
        tapStore.markTapListDirty()
        tapApi.moveBlock(tapStore.currentTap.projectVersion.id,{
            uniqueId: uniqueId,
            aboveOrderIndex: newIndex
        }, tapStore.currentTapLang.lang)
    }

    const removeBlock = (block) => {
        const tapApi = useTapApi();
        const arr = blocks.value
        const index = arr.findIndex(b => b.id === block.id)
        if (index !== -1) arr.splice(index, 1)
        normalizeBlocksOrder()
        tapStore.currentTapLang.changed = true;
        tapStore.markTapListDirty()
        tapApi.removeBlock(tapStore.currentTap.projectVersion.id, block.uniqueId, tapStore.currentTapLang.lang)
    }

    return { blocks, moveBlock, removeBlock, normalizeBlocksOrder, saveMoveBlock }
}
